import React, { useEffect, useState } from 'react';
import * as Icon from 'react-feather';
import currentStage from "../stages.const";
import i18n from "../i18n";

// Define system message types
export type MessagePriority = "INFO" | "WARNING" | "ERROR";

interface SystemMessageType {
    priority: MessagePriority;
    message: string;
    link?: string;
}

const iconLevelMapping = {
    "INFO": <Icon.CheckCircle className="text-success" size={20} aria-hidden={true} />,
    "WARNING": <Icon.AlertCircle className="text-warning" size={20} aria-hidden={true} />,
    "ERROR": <Icon.AlertOctagon className="text-danger" size={20} aria-hidden={true} />,
}

export default function SystemMessageContainer() {
    const [visible, setVisible] = useState(true);
    const [systemMessage, setSystemMessage] = useState<SystemMessageType | null>(null);

    useEffect(() => {
        // Determine system message based on current stage
        // if (currentStage === "PROD") {
        //     setSystemMessage({
        //         priority: "INFO",
        //         message: "Welcome to the new version of FCBookmarks! For more information, please visit our WIKI",
        //         link: "https://w.amazon.com/bin/view/FCBookMarks/"
        //     });
        // } else 
        if (currentStage === "BETA") {
            setSystemMessage({
                priority: "WARNING",
                message: "This tool is being upgraded and turn into readonly mode, please read the link for detail.",
                link: "https://w.amazon.com/bin/view/FCBookMarks/ta_upgrading_version/"
            });
        } else if (currentStage === "ALPHA") {
            setSystemMessage({
                priority: "INFO",
                message: "This is the ALPHA version - features may be unstable",
                link: "https://w.amazon.com/bin/view/FCBookMarks/"
            });
        }
    }, []);

    // Handle message dismissal
    const handleDismiss = () => {
        setVisible(false);
    };

    if (!visible || !systemMessage) return null;

    return (
        <div className="w-system-messages w-100 position-fixed top-0 start-0" style={{ zIndex: 1050 }}>
            <div className="w-system-messages-container w-100">
                <SystemMessage 
                    priority={systemMessage.priority}
                    message={systemMessage.message}
                    link={systemMessage.link}
                    onDismiss={handleDismiss}
                />
            </div>
        </div>
    );
}

interface SystemMessageProps {
    priority: MessagePriority;
    message: string;
    link?: string;
    onDismiss: () => void;
}

function SystemMessage({ priority, message, link, onDismiss }: SystemMessageProps) {
    return (
        <div className="w-system-message w-100" data-testid="system-message-banner">
            <div className={`w-system-message-body w-system-message-${priority.toLowerCase()} w-100 d-flex justify-content-between`}>
                <span className="d-flex align-items-center flex-grow-1">
                    {iconLevelMapping[priority]}
                    <span className="ml-2 w-system-message-content">{message}</span>
                    {link && (
                        <a 
                            className="ml-1 system-message-link" 
                            href={link} 
                            target="_blank" 
                            rel="noopener noreferrer"
                        >
                            {link}
                        </a>
                    )}
                </span>
                <button 
                    type="button" 
                    onClick={onDismiss} 
                    className="close w-system-message-button" 
                    aria-label="Dismiss message"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        </div>
    );
}
